// import Banner from './Banner';
import React from 'react';
import { connect } from 'react-redux';
import agent from '../../agent';
import { Card, Form, Space, Button, Descriptions, InputNumber, Input, Tooltip, Radio } from 'antd';
import FormDrawer from '../../components/FormDrawer/FormDrawer';
import {
  GET_SETTING, UPDATE_SETTING
} from "../../constants/actionTypes";


const mapStateToProps = state => ({
  settings: state.settings,
});

const mapDispatchToProps = (dispatch) => ({
  getSetting: () =>
      dispatch({ type: GET_SETTING, payload: agent.Settings.getSetting() }),
  setSetting: (data) =>
      dispatch({ type: UPDATE_SETTING, payload: agent.Settings.updateSetting(data) }),

});




class Settings extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      btnSize: "small",
    };
  }
  formRef = React.createRef();


  handleSave = () => {
    let apiLimit = this.formRef.current.getFieldValue('paginationTotal')
    let twoFactor = this.formRef.current.getFieldValue('enable2FA')
    console.log('kt 5', apiLimit, twoFactor);
    this.props.setSetting({ apiLimit, twoFactor})
    this.props.getSetting();
  }


  componentWillMount() {
    this.props.getSetting()
    this.setState({radioValue: this.props.two_factor_status})
  }
  componentWillUnmount() {}
  componentDidMount() {
  }
  componentDidUpdate(prevProps) { 
    console.log('kt', this.props.settings, prevProps.settings);
    console.log('kt 2', this.formRef.current.getFieldValue('enable2FA'));
    if (this.props.settings && this.props.settings !== prevProps.settings){
      this.formRef.current.setFieldsValue({
        paginationTotal: this.props.settings.settingPaginationTotal,
        enable2FA: this.props.settings.twoFactorStatus,
      });
    }
  }
  
  render() {


    const { size } = this.props
    const { settingPaginationTotal, twoFactorStatus } = this.props.settings


    return (
      <React.Fragment>
        <div className="grid height_100">
          <Card
            size={this.state.btnSize}
            className="height_100"
            title={<h1>Settings</h1>}
            extra={
              <Tooltip placement="bottom" title="Save">
                <Button type="primary" danger className="btn-green" htmlType="submit" onClick={this.handleSave}>Save</Button>
              </Tooltip>
            }
          >
            <Form
              name="settingForm"
              // size={size}
              onFinish={this.handleSave}
              onFinishFailed={this.props.onFinishFailedSettings}
              initialValues={{
                paginationTotal: settingPaginationTotal,
                enable2FA: twoFactorStatus
              }}
              ref ={this.formRef}
            >

              <Descriptions
                // title="Table Settings"
                bordered
                size={size}
                column={1}
              // extra={<Button size={size} type="primary" danger htmlType="submit" >Save</Button>}
              >
                <Descriptions.Item label="Show total pages in tables">
                  <Form.Item style={{ margin: '0px' }}
                    name="paginationTotal"
                  >
                    <InputNumber min={20} bordered={true}
                      style={{ width: '100%' }} />
                  </Form.Item>
                </Descriptions.Item>
                <Descriptions.Item label="Enable 2FA
                ">
                  <Form.Item style={{ margin: '0px' }}
                    name="enable2FA"
                  >
                    <Radio.Group>
                      <Radio value={0}>On</Radio>
                      <Radio value={1}>Off</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Descriptions.Item>
              </Descriptions>
            </Form>
          </Card>
        </div>


      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings);


// WEBPACK FOOTER //
// src/layouts/views/settings.js